/**
 * Готовит presentation данных состава ПЛАНа.
 * Утилита не знает о Vue-компонентах и использует готовое происхождение с backend.
 */
const ORIGIN_PRESENTATIONS = {
  source: { label: "Данные приложения", colorType: "source" },
  preset: { label: "Из калькулятора", colorType: "value" },
  calculated: { label: "Расчётное", colorType: "calculated" },
};

// Backend определяет происхождение значения, frontend только выбирает его подпись.
export function getBreakdownOriginPresentation(origin) {
  return ORIGIN_PRESENTATIONS[origin] || null;
}

// Собирает token существующего formula tooltip без повторения его предметной логики в компоненте.
export function buildBreakdownTooltipToken(item, tokenLabels = {}) {
  const presentation = getBreakdownOriginPresentation(item?.origin);
  if (!presentation) return null;

  const presetToken = tokenLabels[item.code] || {};
  return {
    ...presetToken,
    label: item.name || presetToken.label || item.code,
    paramType: item.origin === "calculated" ? "calculated" : "value",
    source: item.origin === "source",
    sourceLabel: item.source_name || presetToken.sourceLabel,
  };
}
